<div class="extract-stock container-fluid">
    <h3><Strong>Extrato de Estoque</Strong></h3>
    <mat-card>
      <mat-card-header class="header-padrao">
        <mat-card-title>
          <form class="d-flex align-items-center filtros-header" [formGroup]="filterForm">
            <mat-form-field>
              <mat-label>Filial</mat-label>
              <mat-select formControlName="filial" (selectionChange)="selecionarExtratoEstoque()">
                <mat-option selected value="Todas">Todas</mat-option>
                <mat-option *ngFor="let filial of filiais" [value]="filial?.filialID">
                  {{ filial?.descricao }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field>
              <mat-label>Buscar pelo período de:</mat-label>
              <input matInput
                autocomplete="off"
                maskDate [matDatepicker]="dataInicio"
                (dateChange)="paging.index = 0; selecionarExtratoEstoque()"
                formControlName="fromDate">
              <mat-datepicker-toggle matSuffix [for]="dataInicio"></mat-datepicker-toggle>
              <mat-datepicker #dataInicio></mat-datepicker>
            </mat-form-field>
            <mat-form-field>
              <mat-label>até:</mat-label>
              <input matInput
                autocomplete="off"
                maskDate [matDatepicker]="dataFim"
                (dateChange)="paging.index = 0; selecionarExtratoEstoque()"
                formControlName="toDate">
              <mat-datepicker-toggle matSuffix [for]="dataFim"></mat-datepicker-toggle>
              <mat-datepicker #dataFim></mat-datepicker>
            </mat-form-field>
              <button mat-icon-button (click)="paging.index = 0; clearFields()" matTooltip="Limpar Campos">
                <i class="fas fa-eraser eraser-button"></i>
              </button>
          </form>
        </mat-card-title>
      </mat-card-header>
      <mat-progress-bar [hidden]="!isLoading" color="primary" mode="indeterminate"></mat-progress-bar>
      <mat-card-content class="no-padding">
        <div [hidden]="isLoading || estoqueExtrato?.data?.length === 0">
          <div>
            <table mat-table [dataSource]="estoqueExtrato" matSort>
              <ng-container matColumnDef="data">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Data </th>
                <td mat-cell *matCellDef="let estoqueExtrato"> {{ estoqueExtrato?.data | date: 'dd/MM/yyyy' }} </td>
                <td mat-footer-cell *matFooterCellDef><Strong>Total</Strong></td>
              </ng-container>

              <ng-container matColumnDef="totalEntradas">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Total de Entrada </th>
                <td mat-cell *matCellDef="let estoqueExtrato"> {{ estoqueExtrato?.totalEntradas }} </td>
                <td mat-footer-cell *matFooterCellDef><strong> {{ calcularTotais('totalEntradas') }} </strong></td>
              </ng-container>

              <ng-container matColumnDef="totalSaidas">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Total de Saída </th>
                <td mat-cell *matCellDef="let estoqueExtrato"> {{ estoqueExtrato?.totalSaidas }} </td>
                <td mat-footer-cell *matFooterCellDef><strong>{{ calcularTotais('totalSaidas') }} </strong></td>
              </ng-container>

              <ng-container matColumnDef="totalDevolucao">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Total de Devoluções </th>
                <td mat-cell *matCellDef="let estoqueExtrato"> {{ estoqueExtrato?.totalDevolucao }} </td>
                <td mat-footer-cell *matFooterCellDef><strong> {{ calcularTotais('totalDevolucao') }} </strong></td>
              </ng-container>

              <ng-container matColumnDef="acao">
                <th mat-header-cell *matHeaderCellDef> Ação </th>
                <td mat-cell *matCellDef="let estoqueExtrato">
                  <button mat-flat-button color="primary" (click)="openDetails(estoqueExtrato?.data)">Detalhe</button>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
            </table>
          </div>
          <app-paginacao [pageIndex]="paging?.index"
            [pageSize]="paging?.size"
            [length]="paging?.length"
            (page)="onPageChange($event)"
            [pageSizeOptions]="[10, 20, 50]"></app-paginacao>
        </div>
        <div *ngIf="!isLoading && estoqueExtrato?.data?.length === 0" class="d-flex justify-content-center align-items-center" style="height: 100px;">
          Nenhum registro para o período!
        </div>
      </mat-card-content>
    </mat-card>
  </div>
